var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "If-you-currently-hav",
    transform: "translate(-13.000000, -189.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank-account-details",
    transform: "translate(13.000000, 189.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-241",
    points: "0.833333333 12.5 20.8333333 0.833333333 39.1666667 12.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-242",
    points: "0.833333333 39.1666667 39.1666667 39.1666667 39.1666667 34.1666667 0.833333333 34.1666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-243",
    points: "5.83333333 30.8333333 10.8333333 30.8333333 10.8333333 15.8333333 5.83333333 15.8333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16666667,15.8333333 L5.83333333,15.8333333",
    id: "Stroke-244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16666667,30.8333333 L5.83333333,30.8333333",
    id: "Stroke-245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333333,30.8333333 L12.5,30.8333333",
    id: "Stroke-246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333333,15.8333333 L12.5,15.8333333",
    id: "Stroke-247"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-248",
    points: "17.5 30.8333333 22.5 30.8333333 22.5 15.8333333 17.5 15.8333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333333,15.8333333 L17.5,15.8333333",
    id: "Stroke-249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333333,30.8333333 L17.5,30.8333333",
    id: "Stroke-250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,30.8333333 L24.1666667,30.8333333",
    id: "Stroke-251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,15.8333333 L24.1666667,15.8333333",
    id: "Stroke-252"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-253",
    points: "29.1666667 30.8333333 34.1666667 30.8333333 34.1666667 15.8333333 29.1666667 15.8333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,15.8333333 L29.1666667,15.8333333",
    id: "Stroke-254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,30.8333333 L29.1666667,30.8333333",
    id: "Stroke-255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1666667,30.8333333 L35.8333333,30.8333333",
    id: "Stroke-256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1666667,15.8333333 L35.8333333,15.8333333",
    id: "Stroke-257"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };